module.exports = __webpack_public_path__ + "7ec1f2d0d4378504565a360baf6bb50f.svg";